import { Webhooks } from 'features/webhooks';

export const MerchantWebhooksPage: React.FC = () => <Webhooks />;
